/* eslint-disable func-names, max-len, no-new, no-plusplus, no-shadow, no-underscore-dangle */
if ($('.tablet-container').length > 0) {
  $('.eventSignUpSubmit').click(() => {
    if ($('.tablet-container .text-danger').is(':visible')) {
      $('.tablet-container .inner').height(675);
    } else {
      $('.tablet-container .inner').height(570);
    }
  });
}
